import { render, staticRenderFns } from "./percepciones.vue?vue&type=template&id=79c3b1e6&scoped=true"
import script from "./percepciones.vue?vue&type=script&lang=js"
export * from "./percepciones.vue?vue&type=script&lang=js"
import style0 from "./percepciones.vue?vue&type=style&index=0&id=79c3b1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c3b1e6",
  null
  
)

export default component.exports